import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import "./LoadingSpinner.scss";

interface LoadingSpinnerProps {
  backgroundColor?: "transparent" | "white" | "#FAFAFA";
  type?: "default" | "fullScreen" | "table";
  label?:string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  backgroundColor = "transparent",
  type = "default",
  label=""
}) => {
  const zIndexMap = {
    fullScreen: 9999,
    default: 999,
    table: 99,
  };

  return (
    <Box
      className="loading-spinner"
      sx={{ backgroundColor, zIndex: zIndexMap[type] }}
    >
      <div className="loader-label">{label}</div>
      <CircularProgress color="primary" />
    </Box>
  );
};

export default LoadingSpinner;
